export default function Upload() {
  return (
    <div className="min-h-screen p-8">
      <h1 className="text-4xl font-bold gradient-text">Upload</h1>
      <p className="mt-4 text-star-white/70">Drag & drop upload coming soon...</p>
    </div>
  )
}
